import type LanguageCode from '@alltrails/core/types/LanguageCode';
import type { LanguageRegionCode } from '@alltrails/core/types/LanguageRegionCode';
import { useLanguageRegionCode } from './useLanguageRegionCode';

export function useLanguageCode(): LanguageCode {
  const languageRegionCode: LanguageRegionCode = useLanguageRegionCode();
  return languageRegionCode.split('-')[0] as LanguageCode;
}
